/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 16/05/22
 */

import { ReactComponent as LifetimeOfLearning } from './lifetime_of_learning.svg';
import { ReactComponent as ConnectedResearch } from './connected_research.svg';
import { ReactComponent as DistinctiveIdentity } from './distinctive_identity.svg';
import { ReactComponent as SustainablePartnerships } from './sustainable_partnerships.svg';
import { ReactComponent as WorkingTogether } from './working_together.svg';

export default {
    LifetimeOfLearning,
    ConnectedResearch,
    DistinctiveIdentity,
    SustainablePartnerships,
    WorkingTogether,
};
